import { Component, OnInit } from '@angular/core';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { subscriber } from '../../../../icemedx-lib/src/models/domain/subscriber';
import { IBaseView } from '../../../../icemedx-lib/src/components/baseview.component';
import { IcepanelcontainerSettings, IcecontrolPermission, IcecontrolSettings, IcepanelsectionSettings, IcepanelSettings, IcepanelcontainerRowSettings } from '../../../../icemedx-lib/src/components/models/icesettings';
import { Validators, FormGroup } from '@angular/forms';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { Router } from '@angular/router';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { IceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { entity } from '../../../../icemedx-lib/src/models/common/entity';
import { contact } from '../../../../icemedx-lib/src/models/common/contact';
import { address } from '../../../../icemedx-lib/src/models/common/address';

@Component({
  selector: 'app-addsubscriber',
  templateUrl: './addsubscriber.component.html',
  styleUrls: ['./addsubscriber.component.scss'],
  providers: [AppService, IceNavService]
})
export class AddsubscriberComponent implements OnInit, IBaseView {
  subObj: subscriber = new subscriber();

  // member settings
  addSubscriberViewSettings: IcepanelcontainerSettings = null;
  addSubscriberPermission: IcecontrolPermission = null;

  addSubscriberPanel: IcepanelSettings = null;

  titleOfSubscriberCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { placeholder: "Title", width: "450px" },
    null, null, "IDTitleOfSubscriber", "Enter Title (Mr., Mrs., Dr., or Hon.)")
    .setControlName("IDTitleOfSubscriber")
    .createFormControl("", []);

  firstNameOfSubscriberCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { placeholder: "First Name of Subscriber", width: "450px" },
    null, null, "IDFirstNameOfSubscriber", "Enter First Name of Subscriber")
    .setControlName("IDFirstNameOfSubscriber")
    .createFormControl("", [Validators.required]);

  lastNameOfSubscriberCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { placeholder: "Last Name of Subscriber", width: "450px" },
    null, null, "IDLastNameOfSubscriber", "Enter Last Name of Subscriber")
    .setControlName("IDLastNameOfSubscriber")
    .createFormControl("", [Validators.required]);

  initialOfSubscriberCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { placeholder: "Initial", width: "450px" },
    null, null, "IDInitialOfSubscriber", "Enter Middle Initial of Subscriber")
    .setControlName("IDInitialOfSubscriber")
    .createFormControl("", []);

  additionalNameCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { placeholder: "Other name of Subscriber", width: "450px" },
    null, null, "IDAdditionalName", "Enter Other name of Subscriber")
    .setControlName("IDAdditionalName")
    .createFormControl("", []);

  dateOfBirthCtrl: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "Date of Birth", width: "450px" },
    null, null, "IDDOB", "Enter Date of Birth")
    .setControlName("IDDOB")
    .createFormControl(Iceutility.GetLocalDate(), [Validators.required]);

  gendorCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", {
    menuItems: [
      { name: "Female", value: IceTypes.GENDER.female },
      { name: "Male", value: IceTypes.GENDER.male },
      { name: "Unknown", value: IceTypes.GENDER.unknown }
    ],
    placeholder: "Gender", width: "450px"
    },
    null, null, "IDGender", "Select Gender")
    .setControlName("IDGender")
    .createFormControl("", [Validators.required]);

  phoneCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { placeholder: "Phone number", width: "450px" },
    null, null, "IDPhone", "Enter Phone number")
    .setControlName("IDPhone")
    .createFormControl("", [Validators.required]);

  emailCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { placeholder: "Email", width: "450px" },
    null, null, "IDEmail", "Email")
    .setControlName("IDEmail")
    .createFormControl("", [Validators.required, Validators.email]);

  suffixOfSubscriberCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { placeholder: "Title", width: "450px" },
    null, null, "IDSuffix", "Enter Suffix or Credentials (Sr., Jr., III, MD, PhD.)")
    .setControlName("IDSuffix")
    .createFormControl("", []);

  postalCodeCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { placeholder: "Postal code", width: "450px" },
    null, null, "IDPostalCode", "Enter Postal code")
    .setControlName("IDPostalCode")
    .createFormControl("", [Validators.required]);

  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    private subSvc: PatientService,
    private router: Router) {

    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Add Subscriber", {}, true, "");

    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufDemographics).default_access;
    this.addSubscriberPermission = new IcecontrolPermission(userTypes.USER_FEATURES.ufDemographics, feaAccess);

    if (feaAccess != userTypes.USER_FEATURE_ACCESS.ufaAdd
      && feaAccess != userTypes.USER_FEATURE_ACCESS.ufaFullControl) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      return;
    }

    this.addSubscriberViewSettings = this.viewSetup(this.subObj);
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  viewSetup(dat: IceEntity): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      if (dat == null) {
        return null;
      }

      let headerControls = [
        new IcecontrolSettings("icebutton", { class: "fas fa-check", width: "50px" }, null, null, "SaveReport"),
        new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "CancelReport")
      ];

      let controls: IcecontrolSettings[] = [
        this.titleOfSubscriberCtrl,
        this.firstNameOfSubscriberCtrl,
        this.lastNameOfSubscriberCtrl,
        this.initialOfSubscriberCtrl,
        this.additionalNameCtrl,
        this.suffixOfSubscriberCtrl,
        this.gendorCtrl,
        this.dateOfBirthCtrl,
        this.phoneCtrl,
        this.emailCtrl,
        this.postalCodeCtrl,
      ];

      let addSection = new IcepanelsectionSettings("BillingDomainPanelSection", { class: [""], styles: { width: "100%" } }, null,
        controls, []).setShow(true);

      let sections: IcepanelsectionSettings[] = [
        addSection,
      ];
      this.addSubscriberPanel = new IcepanelSettings("AddSubscriberPanel", Iceutility.guid(false), "Add Subscriber", "", sections, headerControls)
        .enableForm();

      let panels: IcepanelSettings[] = [
        this.addSubscriberPanel,
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings("AddSubscriberViewContainer", panelrows);
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  public onControlChange(event) {
  }

  public onHeaderActionClick(event) {
    if (event.headerCtrl && event.headerCtrl.id == "") {
      return;
    }

    if (event.headerCtrl && event.headerCtrl.id == "CancelReport") {
      // To do: Save Modified Prompt
      this.router.navigate([this.navSvc.buildRoute("payer/subscribersearch", false)]);
      return;
    }

    if (event.headerCtrl instanceof IcecontrolSettings) {
      let billForm: FormGroup = this.addSubscriberPanel.getForm();
      if (billForm == null || false == billForm.valid) {

        // To do log error
        return;
      }

      let ent: entity = null;
      if (this.subObj.ENTS == null)
        this.subObj.ENTS = [];

      if (this.subObj.ENTS.length == 0) {
        ent = new entity();
        ent.entity_key = this.subObj.entity_key = Iceutility.guid(true);
        this.subObj.ENTS.push(ent);
      }
      else {
        ent = this.subObj.ENTS[0];
      }

      ent.first_name = this.firstNameOfSubscriberCtrl.getFormControl().value;
      ent.last_name = this.lastNameOfSubscriberCtrl.getFormControl().value;
      ent.dob = Iceutility.convertToUTCEx(this.dateOfBirthCtrl.getFormControl().value);
      ent.additional_name = this.additionalNameCtrl.getFormControl().value;
      ent.sex = this.gendorCtrl.getFormControl().value;
      ent.prefix = this.titleOfSubscriberCtrl.getFormControl().value;
      ent.suffix = this.suffixOfSubscriberCtrl.getFormControl().value;
      let phone: contact = null;
      let foundContact = this.subObj.CONS.filter(c => c.communication_number_qualifier == "TE");
      if (foundContact.length == 0) {
        phone = new contact();
        phone.contact_key = Iceutility.guid(true);
        phone.communication_number_qualifier = "TE";
        this.subObj.CONS.push(phone);
      }
      else {
        phone = foundContact[0];
      }

      let email: contact = null;
      foundContact = this.subObj.CONS.filter(c => c.communication_number_qualifier == "EM");
      if (foundContact.length == 0) {
        email = new contact();
        email.contact_key = Iceutility.guid(true);
        email.communication_number_qualifier = "EM";
        this.subObj.CONS.push(email);
      }
      else {
        email = foundContact[0];
      }

      phone.communication_number = this.phoneCtrl.getFormControl().value;
      email.communication_number = this.emailCtrl.getFormControl().value;

      let adr: address = null;
      if (this.subObj.ADS == null)
        this.subObj.ADS = [];

      if (this.subObj.ADS.length == 0) {
        adr = new address();
        adr.address_key = this.subObj.address_key = Iceutility.guid(true);
        this.subObj.ADS.push(adr);
      }
      else {
        adr = this.subObj.ADS[0];
      }

      adr.postal_code = this.postalCodeCtrl.getFormControl().value;

      this.subSvc.insertSubscriber(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), this.subObj, "").subscribe(
        data => {
          // To do is error then stay on view
          this.router.navigate([this.navSvc.buildRoute("payer/subscribersearch/" + encodeURIComponent(phone.communication_number), false)]);
        },
        error => {
          console.log(JSON.stringify(this.subSvc.getLastErrors()));
        });
    }
  }
}
